import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  HrFlexContainer,
  HrTitleContainer,
  HrTitleH4,
  HrButtons,
  HrParagraph,
  HrFontBold
} from '@components/styles/hr-styles';
import { Textarea } from '@components/form/textarea';
import { Checkbox } from '@components/form/checkbox';
import { HrButton } from '@components/button/button';
import { Modal } from '../../../postulation_form/components/modal';

export const RejectRequestModal = ({ actualRowId, reject, setShowModalRejectRequest, onShowToast }) => {
  const [t] = useTranslation();
  const ref = useRef('sendmeCopy');

  const { register, formState, handleSubmit, control } = useForm({ mode: 'onSubmit' });

  const onSubmitSuccess = (data) => {
    reject.mutate({
      idRequisition: actualRowId,
      additionalMessage: data.additionalMessage,
      sendCopy: data.sendCopy
    });
  };

  const onSubmitError = () => {
    onShowToast({ visible: true, type: 'error', message: t('requestVacancies.colaborativeSelection.sendMail.error') });
  };

  return (
    <Modal setShowModal={setShowModalRejectRequest}>
      <HrTitleContainer padding='32px 32px 12px 32px'>
        <i className='hr-Close' />
        <HrTitleH4>{t('requestVacancies.colaborativeSelection.modal.rejectRequest.title')}</HrTitleH4>
      </HrTitleContainer>
      <HrFlexContainer padding='16px 32px 0 32px'>
        <HrParagraph>
          <span style={{ fontWeight: HrFontBold }}>
            {t('requestVacancies.colaborativeSelection.modal.rejectRequest.subTitle')}{' '}
          </span>
          {t('requestVacancies.colaborativeSelection.modal.rejectRequest.clarification')}
        </HrParagraph>
        <Textarea
          title={t(`requestVacancies.colaborativeSelection.modal.rejectRequest.form.additionalMessage`)}
          id='additionalMessage'
          register={register}
          formState={formState}
          placeholder={t(
            'requestVacancies.colaborativeSelection.modal.rejectRequest.form.additionalMessagePlaceholder'
          )}
          control={control}
          handleKeyDown={(e) => {
            if (e.keyCode === 13 && !e.shiftKey) {
              e.preventDefault();
            }
            return false;
          }}
        />
        <Checkbox
          label={t('requestVacancies.colaborativeSelection.modal.rejectRequest.form.sendCopy')}
          name='sendCopy'
          refCustom={ref}
          control={control}
          defaultChecked={false}
          onChange={() => {}}
        />
      </HrFlexContainer>
      <HrFlexContainer padding='32px' justifyContent='flex-end' gap='8px'>
        <HrButtons
          type='button'
          category='cancel'
          size='medium'
          onClick={() => {
            setShowModalRejectRequest(false);
          }}
        >
          {t('general.button.close')}
        </HrButtons>
        <HrButton
          type='button'
          category='secondary'
          size='medium'
          onClick={handleSubmit(onSubmitSuccess, onSubmitError)}
          loading={reject.isLoading}
          disabled={reject.isLoading}
          text={t('general.button.reject')}
          name='send'
        />
      </HrFlexContainer>
    </Modal>
  );
};
